import React from 'react';

import './loginBackground.scss';
import loginFormImageSvg from 'assets/login-page-illustration.svg';
import loginFormImageSvgUat from 'assets/login-page-illustration-uat.svg';
import uatWarning from 'assets/uat-warning.svg';
import { PrivacyPolicy } from 'components/PrivacyPolicy/PrivacyPolicy';
import className from 'classnames';
import config from 'config';
// import { Announcement } from 'components/Announcement/Announcement';

export const LoginBackground = ({ children }) => {
  const formImageStyle = className('form-image', {
    fill: true
  });
  return (
    <div className='login-background'>
      {config.isUat && (
        <div className='uat-warning'>
          <img src={uatWarning} alt='uat warning' />
        </div>
      )}
      <div className='form-container'>
        {!config.isUat && (
          <img
            className={formImageStyle}
            src={loginFormImageSvg}
            alt='illustration'
          />
        )}
        {config.isUat && (
          <img
            className={formImageStyle}
            src={loginFormImageSvgUat}
            alt='illustration'
          />
        )}
        {children}
        <div className='bottom-area'>
          {/* <Announcement className='loginPageAnnouncement'/> */}
          <PrivacyPolicy className='loginPagePrivacyPolicy' />
        </div>
      </div>
    </div>
  );
};
